import {
    ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING_SUCCESS,
    ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING_FAILED,
    LOADING_ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING,
    RESET_ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING,
    NETWORK_ERROR_ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING:
            return (state = initialState);
        default:
            return state;
    }
};
